// removed by extract-text-webpack-plugin
module.exports = {"container":"container___3RV9m","content":"content___7jf0N","header":"header___2yjBP","renderNotes":"renderNotes___2j6gv","renderMtls":"renderMtls___3b8sn","headerContainer":"headerContainer___1wbc4"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PreviewMaterial/PreviewMaterial.module.css
// module id = 400
// module chunks = 0